import { PERIODICITIES } from "../data/catalog";
import { PeriodicityId } from "../types";

const brl = new Intl.NumberFormat("pt-BR", {
  style: "currency",
  currency: "BRL",
  minimumFractionDigits: 2,
});

export function formatBRL(value: number): string {
  return brl.format(value);
}

export function formatPriceBound(value: number, max: number): string {
  const label = new Intl.NumberFormat("pt-BR", { maximumFractionDigits: 0 }).format(value);
  return value >= max ? `R$ ${label}+` : `R$ ${label}`;
}

export function periodicitySuffix(id: PeriodicityId): string {
  return PERIODICITIES.find((p) => p.id === id)?.priceSuffix ?? "";
}

export function periodicityLabel(id: PeriodicityId): string {
  return PERIODICITIES.find((p) => p.id === id)?.label ?? "";
}

export function normalize(text: string): string {
  return text.normalize("NFD").replace(/[̀-ͯ]/g, "").toLowerCase().trim();
}
